module.exports = __webpack_public_path__ + "img/logo_contribution.6dbdcae7.png";